import {call, put, select, takeLatest} from "redux-saga/effects";
import {
  fetchAuth,
  fetchAuthDone,
  fetchAuthFail,
  fetchGetNotificationAction,
  fetchGetNotificationActionDone,
  fetchGetNotificationActionFail,
  fetchSetNotificationAction,
  fetchSetNotificationActionDone,
  fetchSetNotificationActionFail,
  fetchUserProfileAction,
  fetchUserProfileActionDone,
  fetchUserProfileActionFail,
  getMenuAction,
  getMenuActionDone,
  getMenuActionFail,
  fetchVerificationCodeAction,
  fetchVerificationCodeActionDone,
  fetchVerificationCodeActionFail,
  fetchRegisterDataAction,
  fetchRegisterDataActionDone,
  fetchRegisterDataActionFail,
} from "./actions";
import {apiAuth, apiGetMenu, apiGetNotification, apiGetUserProfile, apiSetNotification, apiRegistration, apiVerificationCode} from "./api";
import {setTokenCookie} from "../../../hooks/useAuth";
import {PayloadAction} from "@reduxjs/toolkit";
import {RootState} from "../../index";
import {selectStore} from "../../selector";

function* authFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiAuth, payload)
    if (data.user) {
      yield put(fetchAuthDone(data.user))

      yield call(setTokenCookie, data.token)
    }

  } catch (e) {
    yield put(fetchAuthFail())
  }
}

function* getUserProfileFlow({payload}: PayloadAction<any>): any {
  const {profile: {userProfile: dataState}}: RootState = yield select(selectStore)
    try {
      const data = yield call(apiGetUserProfile);
      if (data) {
        yield put(fetchUserProfileActionDone(data.data));
      }
    } catch (e: any) {
      console.warn(e);
      yield put(fetchUserProfileActionFail());
    }
}

function* getMenuFlow({payload}: PayloadAction<any>): any {
  const {profile: {menu: dataState}}: RootState = yield select(selectStore)
  // if (dataState.success) {
  //   yield put(getMenuActionDone(dataState.data));
  // } else {
    try {
      const data = yield call(apiGetMenu);
      if (data.data) {
        let body = data.data.map((item: any) => ({
          label: item.label,
          path: item.open ? item.url : `${process.env.REACT_APP_FULLSTACK_URL}${item.url}`,
          key: item.id,
          icon: item.icon,
          child: item.child,
        }))
        yield put(getMenuActionDone(body));
      }
    } catch (e) {
      console.error(e);
      yield put(getMenuActionFail());
    }
  // }
}

function* getNotificationFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiGetNotification);
    if (data.data) {
      yield put(fetchGetNotificationActionDone(data.data?.notifications));
    }
  } catch (e) {
    console.error(e);
    yield put(fetchGetNotificationActionFail());
  }
}

function* setNotificationFlow({payload}: PayloadAction<any>): any {
  try {
    const data = yield call(apiSetNotification);
    if (data.data) {
      yield put(fetchSetNotificationActionDone(data));
    }
  } catch (e) {
    console.error(e);
    yield put(fetchSetNotificationActionFail());
  }
}


//entrant
function* registrationFlow({payload}:any):any {
  try {
    const data = yield call(apiRegistration, payload)

    if(data){
      yield put(fetchRegisterDataActionDone(data))
    }
  } catch (e) {
    yield put(fetchRegisterDataActionFail())
  }
}

function* verificationCodeFlow({payload}:any):any {
  try {
    const data = yield call(apiVerificationCode, payload)

    if(data){
      yield put(fetchVerificationCodeActionDone(data))
    }
  } catch (e) {
    yield put(fetchVerificationCodeActionFail())
  }
}


export default function* profileSaga() {
  yield takeLatest(fetchAuth, authFlow);
  yield takeLatest(fetchUserProfileAction, getUserProfileFlow);
  yield takeLatest(getMenuAction, getMenuFlow);
  yield takeLatest(fetchGetNotificationAction, getNotificationFlow);
  yield takeLatest(fetchSetNotificationAction, setNotificationFlow);

  //entrant
  yield takeLatest(fetchRegisterDataAction, registrationFlow);
  yield takeLatest(fetchVerificationCodeAction, verificationCodeFlow);

}
